module.exports = __webpack_public_path__ + "public/img/bihuanlv.ab55d416.png";